export enum InventoryItemMediaType {
  Image = 1,
  Video = 2,
}
